import { LegacyPortalSearchResultLabel } from "@spwn-portal/grpc/build";
import { STATUS } from "ui/StatusLabel/constants/status";

import type { Status } from "ui/StatusLabel/types/status";

export const SEARCH_RESULT_STATUS_MAP: Record<
  LegacyPortalSearchResultLabel,
  Status
> = {
  [LegacyPortalSearchResultLabel.UNSPECIFIED]: STATUS.NO_LABEL,
  [LegacyPortalSearchResultLabel.NONE]: STATUS.NO_LABEL,
  [LegacyPortalSearchResultLabel.BEFORE_SALE]: STATUS.BEFORE_SALE,
  [LegacyPortalSearchResultLabel.ON_SALE]: STATUS.ON_SALE,
  [LegacyPortalSearchResultLabel.END]: STATUS.END,
  [LegacyPortalSearchResultLabel.A_FEW_LEFT]: STATUS.A_FEW_LEFT,
  [LegacyPortalSearchResultLabel.SOLD_OUT]: STATUS.SOLD_OUT,
  [LegacyPortalSearchResultLabel.NEW]: STATUS.NEW,
};
